module.exports = __webpack_public_path__ + "img/swift-sport-negro-supremo.de41682a.png";